import { Button, Input, Modal, Typography } from "antd";
import { forwardRef, useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";

export type VerifyIdentitiesModalType = {
  open: () => void;
  close: () => void;
};

export const VerifyIdentitiesModal = forwardRef<
  VerifyIdentitiesModalType,
  {
    error: any;
    isPending: boolean;
    inn: string;
    setInn: (e: string) => void;
    mutate: () => void;
  }
>(({ error, isPending, inn, setInn, mutate }, ref) => {
  const { t } = useTranslation();
  const [opened, setOpened] = useState<boolean>(false);

  const open = () => {
    setOpened(true);
  };

  const close = () => {
    setOpened(false);
  };

  useImperativeHandle(ref, () => ({
    open: () => open(),
    close: () => close(),
  }));

  return (
    <Modal
      title={
        <Typography.Title level={3}>
          {t("identity_verification.inn_modal_title")}
        </Typography.Title>
      }
      open={opened}
      onCancel={() => {
        setOpened(false);
      }}
      footer={
        <Button
          type="primary"
          loading={isPending}
          disabled={isPending}
          onClick={() => mutate()}
        >
          {t("common.confirm")}
        </Button>
      }
      destroyOnHidden
    >
      <Typography.Text style={{ display: "block", marginBottom: 12 }}>
        {t("identity_verification.inn_modal_description")}
      </Typography.Text>
      <Input
        placeholder={t("identity_verification.inn_placeholder")}
        value={inn}
        inputMode="numeric"
        onChange={(e) => setInn(e.target.value)}
      />
      <Typography.Text
        type="secondary"
        style={{ marginTop: 8, display: "block" }}
      >
        {t("identity_verification.inn_hint")}
      </Typography.Text>

      {!!error && (
        <Typography.Text
          style={{ marginTop: 8, display: "block" }}
          type="danger"
        >
          {(error as any).response?.data?.message ||
            (error as any).response?.data?.error?.description}
        </Typography.Text>
      )}
    </Modal>
  );
});
